export const getContextMenuPosition = (event) => ({
  top: event.clientY,
  left: event.clientX,
});

